import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../shared/auth/auth.service'; // Import your AuthService to handle logout

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {
  private timeoutId: any;
  private readonly timeoutDuration = environment.sessionTimeoutInMinutes * 60 * 1000; // Convert to milliseconds

  constructor(private router: Router, private ngZone: NgZone, private authService: AuthService) {}

  startTimer(): void {
    this.clearTimer();
    this.timeoutId = setTimeout(() => {
      this.signOut();
    }, this.timeoutDuration);
  }

  clearTimer(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  resetTimer(): void {
    this.startTimer();
  }

  private signOut(): void {
    this.clearTimer();
    this.authService.signOut(); // Call logout method to clear session data
    window.location.href = environment.msSignoutURL; // Redirect to Microsoft sign-out
  }
}
